export default {
  chat: 'Chat',
  conversations: 'Conversations',
  search: 'Search conversations',
  favorites: 'Favorites',
  team_channels: 'Team channels',
  namedTeamChannels: '{{name}} channels',
  channels: 'Channels',
  allChannels: 'All channels',
  direct_messages: 'Direct messages',
  empty: 'No conversations yet',
  emptyFavorites: 'Star conversations to keep them here.',
  emptySection: 'No channels in this section.',
  emptySmartSection: 'No conversations match this rule.',
  noResults: 'No matching conversations',
  loadMore: 'Load more',
  retry: 'Retry',
  newSection: 'New section',
  createSection: 'Create section',
  renameSection: 'Rename section',
  deleteSection: 'Delete section',
  deleteConfirmTitle: 'Delete “{{name}}”?',
  deleteConfirmBody:
    '{{scopeDescription}} {{channelsText}} Nobody loses access to a channel.',
  deleteSmartChannels:
    'Channels stop appearing in this smart label. Other labels are unchanged.',
  deleteEmptyChannels: 'It has no channels in it.',
  created: 'Created “{{name}}”',
  updated: 'Updated “{{name}}”',
  deleted: 'Deleted “{{name}}”',
  movedChannel: 'Moved {{channel}} to “{{name}}”',
  removedChannel: 'Removed {{channel}} from “{{name}}”',
  unnamedChannel: 'the channel',
  deleteLabelFailed: 'Failed to delete label',
  moveChannelFailed: 'Failed to move channel',
  markLabelReadFailed: 'Failed to mark channel label as read',
  muteAllChannels: 'Mute all channels',
  unmuteAllChannels: 'Unmute all channels',
  snoozeAllChannels: 'Snooze all channels',
  notificationsFailed:
    'Could not update section notifications. Please try again.',
  deleteForEveryone: 'Delete for everyone',
  sectionName: 'Section name',
  manageSections: 'Manage sections',
  sections: 'Sections',
  optionsFor: 'Options for {{name}}',
  expandSection: 'Expand section',
  collapseSection: 'Collapse section',
  resizeSection: 'Resize {{name}}',
  resizeSectionHint: 'Drag to resize. Double-click to reset.',
  reorderSection: 'Reorder {{name}}',
  reorderSectionHint: 'Drag to reorder.',
  expandAllSections: 'Expand all sections',
  collapseAllSections: 'Collapse all sections',
  loading: 'Loading sections…',
  noAccess: 'You do not have access to these sections.',
  labelsNoAccess: 'You do not have access to these labels.',
  unavailable: 'Sections are unavailable right now.',
  ineligibleChannel: 'This conversation cannot be added to this section.',
  conversationsRemain:
    'Its conversations remain available in other sections or in the channel list.',
  newPersonalSection: 'Personal section',
  newTeamSection: 'Shared section',
  newSmartSection: 'Smart section',
  newTeamSmartSection: 'Shared smart section',
  sharedShort: 'Shared',
  personal: 'Personal',
  shared: 'Shared with team',
  sharedSectionHint: 'Shared with your team. Team channels only.',
  cannotDropHere: 'This item cannot be added here.',
  smartSectionDropHint: 'Smart sections add channels by name, not by dragging.',
  alreadyInSection: 'This channel is already in this section.',
  reorderingSection: 'Reordering section',
  personalDescription: 'Only you can see and organize this section.',
  teamDescription: 'Everyone on your team can see and organize this section.',
  addToSection: 'Add to section',
  removeFrom: 'Remove from “{{name}}”',
  createChannelOrDirectMessage: 'Create channel or direct message',
  newChannel: 'New channel',
  newDirectMessage: 'New direct message',
  editSection: 'Edit section',
  sectionDescription: 'Organize conversations in a section.',
  sectionVisibility: 'Visibility',
  sectionKind: 'Section type',
  manualSection: 'Manual section',
  nameContains: 'Name contains',
  patternExample: 'e.g. support',
  matchedChannels: 'Matched channels',
  matchingChannelsLoading: 'Matching channels…',
  matchesUnavailable: 'Could not load matches.',
  noMatchingChannels: 'No channels match yet.',
  moreChannelsMatched: {
    one: '+{{count}} more channel matched',
    other: '+{{count}} more channels matched',
  },
  saving: 'Saving…',
  saveSection: 'Save section',
  saveSectionFailed: 'Could not save section. Please try again.',
  sort: 'Sort',
  filter: 'Filter',
  lastViewed: 'Last viewed',
  lastUpdated: 'Last updated',
  dateCreated: 'Date created',
  alphabetical: 'Alphabetical',
  customOrder: 'Custom order',
  reorderFavoritesFailed: 'Could not reorder favorites. Please try again.',
  unreadOnly: 'Unread only',
  noUnreadConversations: 'No unread conversations',
  addChannels: 'Add channels',
  addChannelsTo: 'Add channels to “{{name}}”',
  searchChannels: 'Search channels',
  loadingChannels: 'Loading channels…',
  channelsUnavailable: 'Could not load channels.',
  noChannelsToAdd: 'No more channels are available to add.',
  teamChannelsOnly:
    'Shared sections only include channels from your team that you have joined. Private and public channels belong in personal sections.',
  personalChannelsHint:
    'Personal sections can include team, public, and private channels you have joined.',
  addPersonalChannelsHint:
    'Add any joined channel. Moves channels from other personal sections.',
  addSharedChannelsHint:
    'Add joined team channels. Moves channels from other shared sections.',
  addSelectedChannels: {
    one: 'Add {{count}} channel',
    other: 'Add {{count}} channels',
  },
  addedChannels: {
    one: 'Added {{count}} channel',
    other: 'Added {{count}} channels',
  },
  addChannelsFailed: {
    one: '{{count}} channel could not be added. Retry to add it.',
    other: '{{count}} channels could not be added. Retry to add them.',
  },
  editRule: 'Edit rule',
  showAllChannels: 'Show all channels',
  matchCount: {
    one: '{{count}} matching channel',
    other: '{{count}} matching channels',
  },
  noMatchingTeamChannels:
    'No joined team channels match this name. Try a different rule or use a personal section.',
  cancel: 'Cancel',
};
